(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mwc-markets-core"), require("sortablejs"), require("resize-observer-polyfill"), require("intersection-observer"));
	else if(typeof define === 'function' && define.amd)
		define(["mwc-markets-core", "sortablejs", "resize-observer-polyfill", "intersection-observer"], factory);
	else if(typeof exports === 'object')
		exports["mwcMarketsWatchlist"] = factory(require("mwc-markets-core"), require("sortablejs"), require("resize-observer-polyfill"), require("intersection-observer"));
	else
		root["mwcMarketsWatchlist"] = factory(root["mwcMarketsCore"], root["Sortable"], root["ResizeObserver"], root["IntersectionObserver"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__18__, __WEBPACK_EXTERNAL_MODULE__127__, __WEBPACK_EXTERNAL_MODULE__128__, __WEBPACK_EXTERNAL_MODULE__180__) {
return 